export default __webpack_public_path__ + "static/media/clickdeploy.e2b3394a.svg";